import axios from 'axios'
import HTTP from './http'

export default {
    getClientsByCase: payload => axios.get(HTTP.INSURANCE_CASE_CLIENTS, { params: payload })
}
